/**
 * @file Extends slick to handle multiple navigation buttons.
 */
(function($, Drupal) {
  Drupal.behaviors.boemSlick = {
    attach: function(context, settings) {

      // Add active class to slick navigation per slide.
      var activeClass = 'slick-active';
      var ariaAttribute = 'aria-hidden';
      $('.slick', context).on('init', function() {
        $('.js-slick__caption-navigation-bars li:first-of-type').addClass(activeClass);
      }).on('afterChange', function(event, slick, currentSlide) {
        var $bars = $('.js-slick__caption-navigation-bars');
        $('li', $bars).removeClass(activeClass);
        $bars.each(function() {
          $('li', $(this)).eq(currentSlide).addClass(activeClass);
        });
      });
    }
  };
})(jQuery, Drupal);

(function ($, Drupal) {
  Drupal.behaviors.slickPlayPause = {
    attach: function (context, settings) {
      $('.slick-slider', context).once('slickPlayPause').each(function () {
        var $slider = $(this);
        var $button = $('<button class="slick-play-pause">Pause</button>');
        
        $button.on('click', function () {
          if ($slider.hasClass('slick-paused')) {
            $slider.slick('slickPlay');
            $button.text('Pause');
          } else {
            $slider.slick('slickPause');
            $button.text('Play');
          }
          $slider.toggleClass('slick-paused');
        });

        $slider.append($button);
      });
    }
  };
})(jQuery, Drupal);
